/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.conglomerateMemberships.internal

import features.conglomerateMemberships.models.Businesses
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class ConglomerateMembershipsRequest : NetworkRequest() {

    suspend fun getConglomerateMemberships(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<Businesses> {
        return safeNetworkCall {
            get(
                endpoint = ConglomerateMembershipsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
